<template>
    <v-container class="pa-0 ma-0">
        <v-row>
            <v-col cols="12">
                <h1>Настройка бота FitSecretShopper</h1>

            </v-col>
        </v-row>
        <v-dialog v-if="compared" v-model="dialogZones" fullscreen hide-overlay transition="dialog-bottom-transition">
            <template v-slot:activator="{ on }">
                <v-btn color="primary" dark v-on="on">Редактор блоков</v-btn>
            </template>
            <v-card>
                <v-toolbar dark color="primary">
                    <v-btn icon dark @click="dialogZones = false">
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                    <v-toolbar-title>Настройка блоков</v-toolbar-title>
                    <div class="flex-grow-1"></div>
                </v-toolbar>
                <v-col cols="12" md="12" sm="12">

                    <v-simple-table>
                        <template v-slot:default>
                            <thead>
                            <tr>
                                <th class="text-left">Название</th>
                                <th class="text-left">Пролог</th>
                                <th class="text-left">Эпилог</th>
                                <th class="text-left" width="180">Следующий блок</th>
                                <th class="text-left">Действия</th>
                            </tr>
                            </thead>
                            <tbody>
                            <tr class="light-green lighten-3">
                                <td>
                                    <v-text-field label="Новая зона" v-model="newzone.name"></v-text-field>
                                </td>
                                <td>
                                    <v-textarea label="Пролог" v-model="newzone.prolog"></v-textarea>
                                </td>
                                <td>
                                    <v-textarea label="Эпилог" v-model="newzone.epilog"></v-textarea>
                                </td>
                                <td>
                                    <v-text-field label="Следующий блок" v-model="newzone.nextblock"></v-text-field>
                                </td>
                                <td>
                                    <v-btn @click="addBlock" :disabled="newzone.name === null || newzone.name === ''" small color="success">
                                        <v-icon dark >mdi-plus</v-icon>
                                    </v-btn>
                                </td>
                            </tr>
                            <tr v-for="item in blocks" :key="item.block_id">
                                <td>
                                    <v-text-field v-model="item.block_name"></v-text-field>
                                </td>
                                <td>
                                    <v-textarea label="Пролог" v-model="item.prolog"></v-textarea>
                                </td>
                                <td>
                                    <v-textarea label="Эпилог" v-model="item.epilog"></v-textarea>
                                </td>
                                <td>
                                    <v-select label="Следующий блок" :items="blocks" item-value="block_id" item-text="block_name" v-model="item.next_block_id" ></v-select>
                                </td>
                                <td>
                                    <v-btn color="warning" class="mr-3" small @click="deleteBlock(item.block_id)">
                                        <v-icon dark>mdi-close</v-icon>
                                    </v-btn>
                                    <v-btn color="success" small @click="saveBlock(item)">
                                        <v-icon dark>mdi-content-save-outline</v-icon>
                                    </v-btn>
                                </td>
                            </tr>

                            </tbody>
                        </template>
                    </v-simple-table>
                </v-col>
            </v-card>
        </v-dialog>
        <v-dialog v-if="compared" v-model="dialogQuestions" fullscreen hide-overlay transition="dialog-bottom-transition">
            <template v-slot:activator="{ on }">
                <v-btn color="primary" class="ml-3" dark v-on="on">Редактор шагов</v-btn>
            </template>
            <v-card>
                <v-toolbar dark color="primary">
                    <v-btn icon dark @click="dialogQuestions = false">
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                    <v-toolbar-title>Настройка вопросов</v-toolbar-title>
                    <div class="flex-grow-1"></div>
                </v-toolbar>
                <v-col cols="12">
                    <v-select :items="blocks" v-model="selectedBlock" item-text="block_name" item-value="block_id" label="Блок"></v-select>
                </v-col>
                <v-col cols="12" md="12" sm="12">
                    <v-dialog v-model="editStepDialog" max-width="600px">
                        <v-card>
                            <v-card-title>
                                <span class="headline">Вопрос</span>
                            </v-card-title>
                            <v-card-text>
                                <v-container>
                                    <v-row v-if="editStepIndex !== null">
                                        <v-col cols="12" sm="6" md="6"><v-text-field label="Множитель" dense type="number" v-model="steps[editStepIndex].factor"></v-text-field></v-col>
                                        <v-col cols="12" sm="6" md="6"><v-checkbox dense label="Можно пропустить" v-model="steps[editStepIndex].skip" :false-value="0" :true-value="1"></v-checkbox></v-col>
                                        <v-col cols="12">
                                            <v-select :items="qTypes" dense v-model="steps[editStepIndex].type" item-text="name" item-value="value" label="Тип вопроса"></v-select>
                                        </v-col>
                                        <v-col cols="12"><v-select :items="qAdmins" dense v-model="steps[editStepIndex].admin_block_id" item-text="admin_block_name" item-value="admin_block_id" label="Блок в админке"></v-select></v-col>
                                        <v-col cols="12"><v-select :items="cats" dense v-model="steps[editStepIndex].cat_id" item-text="cat_name" item-value="cat_id" label="Категория ШБ"></v-select></v-col>
                                        <v-col cols="12"><v-textarea label="Текст задания" dense v-model="steps[editStepIndex].question"></v-textarea></v-col>
                                        <v-col cols="12"><v-textarea label="Текст действия (для бота)" dense v-model="steps[editStepIndex].action"></v-textarea></v-col>
                                        <v-col cols="12"><v-textarea label="Текст в акт" dense v-model="steps[editStepIndex].act_text"></v-textarea></v-col>
                                        <v-col cols="12"><v-textarea label="Файл" dense v-model="steps[editStepIndex].file"></v-textarea></v-col>
                                        <v-col cols="12"><v-checkbox v-model="steps[editStepIndex].exclude_from_repair" label="Исключить из проверки с ЗЧ" :true-value="1" :false-value="null"></v-checkbox></v-col>
                                    </v-row>
                                </v-container>
                            </v-card-text>
                            <v-card-actions>
                                <v-spacer></v-spacer>
                                <v-btn color="blue darken-1" text @click="closeEdit">Закрыть</v-btn>
                                <v-btn color="blue darken-1" text @click="saveEdit">Сохранить</v-btn>
                            </v-card-actions>
                        </v-card>
                    </v-dialog>
                    <v-dialog v-model="newStepDialog" max-width="600px">
                        <v-card>
                            <v-card-title>
                                <span class="headline">Новый вопрос</span>
                            </v-card-title>
                            <v-card-text>
                                <v-container>
                                    <v-row>
                                        <v-col cols="12"><v-select :items="qTypes" label="Тип вопроса" dense v-model="newQ.type" item-text="name" item-value="value"></v-select></v-col>
                                        <v-col cols="12"><v-textarea rows="1" dense label="Текст задания" placeholder="Текст задания" v-model="newQ.question"></v-textarea></v-col>
                                        <v-col cols="12"><v-textarea rows="1" dense placeholder="Текст действия" label="Текст действия" v-model="newQ.action"></v-textarea></v-col>
                                        <v-col cols="12"><v-text-field dense v-model="newQ.factor" label="Коэффициент оценки" type="number" min="1" max="2"></v-text-field></v-col>
                                        <v-col cols="12"><v-checkbox dense v-model="newQ.skip" label="Можно исключить" :false-value="0" :true-value="1"></v-checkbox></v-col>
                                        <v-col cols="12"><v-textarea rows="1" dense label="Файл" placeholder="Идентификатор файла из телеграм или оставьте пустым" v-model="newQ.file"></v-textarea></v-col>
                                        <v-col cols="12"><v-textarea rows="3" dense  label="Текст для акта" placeholder="Текст для акта" v-model="newQ.act_text"></v-textarea></v-col>
                                        <v-col cols="12"><v-select :items="qAdmins" dense label="Блок в отчете" v-model="newQ.admin_block_id" item-text="admin_block_name" item-value="admin_block_id"></v-select></v-col>
                                        <v-col cols="12"><v-select :items="cats" dense label="Категория ШБ" v-model="newQ.cat_id" item-text="cat_name" item-value="cat_id"></v-select></v-col>
                                        <v-col cols="12"><v-checkbox v-model="newQ.exclude_from_repair" label="Исключить из ремонта" :true-value="1" :false-value="null"></v-checkbox></v-col>
                                    </v-row>
                                </v-container>
                            </v-card-text>
                            <v-card-actions>
                                <v-spacer></v-spacer>
                                <v-btn color="blue darken-1" text @click="newStepDialog = false">Закрыть</v-btn>
                                <v-btn color="blue darken-1" text @click="addStep">Добавить вопрос</v-btn>
                            </v-card-actions>
                        </v-card>
                    </v-dialog>
                    <v-row>
                        <v-col cols="12"><v-btn :disabled="selectedBlock === null" color="success" @click="newStepDialog = true">Добавить вопрос</v-btn></v-col>
                    </v-row>
                    <v-simple-table>
                        <template v-slot:default>
                            <thead>
                            <tr>
                                <th class="text-left">Тип</th>
                                <th class="text-left" width="500">Текст задания</th>
                                <th class="text-left" width="90">Можно проп.</th>
                                <th class="text-left" width="90">Порядок</th>
                                <th v-if="!!ui.repair" class="text-left" width="90">Искл. из ЗЧ</th>
                                <th class="text-left" width="150">Действия</th>
                            </tr>
                            </thead>
                            <tbody>
                            <tr v-for="(item, index) in steps" :key="item.step_id">
                                <td>
                                    <v-select :items="qTypes" dense v-model="item.type" item-text="name" item-value="value" label="Тип"></v-select>
                                </td>
                                <td>
                                    <v-textarea rows="3" dense placeholder="Текст задания" v-model="item.question"></v-textarea>
                                </td>
                                <td>
                                    <v-checkbox dense v-model="item.skip" :false-value="0" :true-value="1"></v-checkbox>
                                </td>
                                <td>
                                    <v-text-field dense v-model="item.order"></v-text-field>
                                </td>
                                <td v-if="!!ui.repair"><v-checkbox dense v-model="item.exclude_from_repair" :true-value="1" :false-value="null"></v-checkbox></td>
                                <td>
                                    <div>
                                        <v-btn @click="editStepItem(index, item)" small icon color="info" class="mr-1">
                                            <v-icon small dark>mdi-pencil</v-icon>
                                        </v-btn>
                                        <v-btn @click="preDeleteQuestion(index)" small icon color="error" class="mr-1">
                                            <v-icon small dark>mdi-delete</v-icon>
                                        </v-btn>
                                        <v-btn @click="saveQuestion(index)" small icon color="success" class="mr-1">
                                            <v-icon small dark>mdi-content-save</v-icon>
                                        </v-btn>
                                    </div>
                                    <div>
                                        <v-btn @click="itemDown(index)" small icon color="info"
                                               :disabled="index == steps.length - 1" class="mr-1">
                                            <v-icon small dark>mdi-arrow-down-bold</v-icon>
                                        </v-btn>

                                        <v-btn @click="itemUp(index)" small color="info" icon :disabled="index == 0"
                                               class="mr-1">
                                            <v-icon small dark>mdi-arrow-up-bold</v-icon>
                                        </v-btn>
                                    </div>
                                </td>
                            </tr>
                            </tbody>
                        </template>
                        <!--<template v-slot:default>
                            <thead>
                            <tr>
                                <th class="text-left" width="150">Тип</th>
                                <th class="text-left" width="210">Текст задания</th>
                                <th v-if="!!ui.action" width="200" class="text-left">Текст действия</th>
                                <th class="text-left" width="80">Коэф.</th>
                                <th class="text-left" width="90">Можно проп.</th>
                                <th v-if="!!ui.file" class="text-left">ID Файла</th>
                                <th class="text-left" width="200">Текст для акта</th>
                                <th class="text-left" width="120">Админка</th>
                                <th class="text-left" width="180">Категория ШБ</th>
                                <th class="text-left" width="90">Порядок</th>
                                <th v-if="!!ui.repair" class="text-left" width="90">Искл. из ЗЧ</th>
                                <th class="text-left" width="180">Действия</th>
                            </tr>
                            </thead>
                            <tbody>
                            <tr v-if="selectedBlock > 0" class="light-green lighten-3">
                                <td>
                                    <v-select :items="qTypes" dense v-model="newQ.type" item-text="name" item-value="value" label="Тип"></v-select>
                                </td>
                                <td>
                                    <v-textarea rows="1" dense placeholder="Текст задания" v-model="newQ.question"></v-textarea>
                                </td>
                                <td v-if="!!ui.action">
                                    <v-textarea rows="1" dense placeholder="Текст действия" v-model="newQ.action"></v-textarea>
                                </td>
                                <td>
                                    <v-text-field dense v-model="newQ.factor" type="number" min="1" max="2"></v-text-field>
                                </td>
                                <td>
                                    <v-checkbox dense v-model="newQ.skip" :false-value="0" :true-value="1"></v-checkbox>
                                </td>
                                <td v-if="!!ui.file">
                                    <v-textarea rows="1" dense placeholder="Идентификатор файла из телеграм или оставьте пустым" v-model="newQ.file"></v-textarea>
                                </td>
                                <td>
                                    <v-textarea rows="3" dense placeholder="Текст для акта" v-model="newQ.act_text"></v-textarea>
                                </td>
                                <td>
                                    <v-select :items="qAdmins" dense v-model="newQ.admin_block_id" item-text="admin_block_name" item-value="admin_block_id" label="Тип"></v-select>
                                </td>
                                <td>
                                    <v-select :items="cats" dense v-model="newQ.cat_id" item-text="cat_name" item-value="cat_id" label="Категория ШБ"></v-select>
                                </td>
                                <td>
                                    <v-text-field dense disabled v-model="newQ.order"></v-text-field>
                                </td>
                                <td v-if="!!ui.repair" ><v-checkbox v-model="newQ.exclude_from_repair" :true-value="1" :false-value="null"></v-checkbox></td>
                                <td>
                                    <v-btn @click="addStep" small color="success">
                                        <v-icon dark :disabled="false">mdi-plus</v-icon>
                                    </v-btn>
                                </td>
                            </tr>
                            <tr v-for="(item, index) in steps" :key="item.step_id">
                                <td>
                                    <v-select :items="qTypes" dense v-model="item.type" item-text="name" item-value="value" label="Тип"></v-select>
                                </td>
                                <td>
                                    <v-textarea rows="3" dense placeholder="Текст задания" v-model="item.question"></v-textarea>
                                </td>
                                <td v-if="!!ui.action">
                                    <v-textarea rows="3" dense placeholder="Текст действия" v-model="item.action"></v-textarea>
                                </td>
                                <td>
                                    <v-text-field dense v-model="item.factor" type="number" min="1" max="2"></v-text-field>
                                </td>
                                <td>
                                    <v-checkbox dense v-model="item.skip" :false-value="0" :true-value="1"></v-checkbox>
                                </td>
                                <td v-if="!!ui.file">
                                    <v-textarea rows="3" dense placeholder="Идентификатор файла из телеграм или оставьте пустым" v-model="item.file"></v-textarea>
                                </td>
                                <td>
                                    <v-textarea rows="3" dense placeholder="Текст для акта" v-model="item.act_text"></v-textarea>
                                </td>
                                <td>

                                </td>
                                <td>

                                </td>
                                <td>
                                    <v-text-field dense v-model="item.order"></v-text-field>
                                </td>
                                <td v-if="!!ui.repair"><v-checkbox dense v-model="item.exclude_from_repair" :true-value="1" :false-value="null"></v-checkbox></td>
                                <td>
                                    <div>
                                        <v-btn @click="preDeleteQuestion(index)" small color="error" class="mr-1">
                                            <v-icon dark>mdi-delete</v-icon>
                                        </v-btn>
                                        <v-btn @click="saveQuestion(index)" small color="success" class="mr-1">
                                            <v-icon dark>mdi-content-save</v-icon>
                                        </v-btn>
                                    </div>
                                    <div>
                                        <v-btn @click="itemDown(index)" small color="info"
                                               :disabled="index == steps.length - 1" class="mr-1">
                                            <v-icon dark>mdi-arrow-down-bold</v-icon>
                                        </v-btn>

                                        <v-btn @click="itemUp(index)" small color="info" :disabled="index == 0"
                                               class="mr-1">
                                            <v-icon dark>mdi-arrow-up-bold</v-icon>
                                        </v-btn>
                                    </div>
                                </td>
                            </tr>

                            </tbody>
                        </template>-->

                    </v-simple-table>
                </v-col>
            </v-card>
        </v-dialog>

        <v-dialog v-if="compared" v-model="confirmDeleteQuestion" persistent max-width="290">
            <v-card>
                <v-card-title class="headline">Вы действительно хотите удалить этот вопрос?</v-card-title>
                <v-card-text>Внимание! Удаление необратимо!</v-card-text>
                <v-card-actions>
                    <div class="flex-grow-1"></div>
                    <v-btn color="success" text @click="confirmDeleteQuestion = false">Оставить</v-btn>
                    <v-btn color="error" text @click="deleteQuestion(deleteQuestionIndex)">Удалить</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

    </v-container>
</template>
<script>
  export default {
    data: () => ({
      editStepDialog: false,
      newStepDialog: false,
      editStepIndex: null,
      ui: {
        action: true,
        file: true,
        repair: false,
      },
      compared: true,
      deleteQuestionIndex: 0,
      confirmDeleteQuestion: false,
      dialogZones: false,
      dialogQuestions: false,
      newzone: {
        name: null,
        prolog: null,
        epilog: null,
        nextblock: null
      },
      cats: [],
      newQ: {
        type: 'commentOnNo',
        question: '',
        skip: 0,
        action: '',
        file: '',
        factor: 1,
        code: 0,
        order: 1,
        admin_block_id: 0,
        block_id: 0,
        cat_id: 0,
        act_text: '',
        exclude_from_repair: null,
      },
      steps: [],
      selectedBlock: null,
      qTypes: [
        { name: 'Комментарий если ответ "Нет"', value: 'commentOnNo' },
        { name: 'Комментарий если ответ "Да"', value: 'commentOnYes' },
        { name: 'Комментарий без кнопок', value: 'comment' },
        { name: 'Отправить фото если ответ "Да"', value: 'photoOnYes' },
        { name: 'Отправить фото если ответ "Нет"', value: 'photoOnNo' },
        { name: 'Отправить фото', value: 'sendPhoto' },
      ],
      qAdmins: [
        { admin_block_name: 'БЕЗ ПРИВЯЗКИ К БЛОКУ', admin_block_id: 0 },
        { admin_block_name: 'Прилегающая территория', admin_block_id: 1 },
        { admin_block_name: 'Фасад Автосервиса, Вывеска, Входная зона', admin_block_id: 2 },
        { admin_block_name: 'Автосервис: Зона Приемки', admin_block_id: 3 },
        { admin_block_name: 'Общение с клиентом: Прием автомобиля.', admin_block_id: 4 },
        { admin_block_name: 'Автосервис: Клиентская зона', admin_block_id: 5 },
        { admin_block_name: 'Туалетная комната', admin_block_id: 6 },
        { admin_block_name: 'Ремонтный бокс', admin_block_id: 7 },
        { admin_block_name: 'Общение с клиентом: Выдача автомобиля.', admin_block_id: 8 },
        { admin_block_name: 'Превосходя ожидания клиентов', admin_block_id: 9 },
        { admin_block_name: 'Дополнительные вопросы (свободный ответ)', admin_block_id: 10 },
        { admin_block_name: 'Шапка анкеты', admin_block_id: 11 },
        { admin_block_name: 'Документы', admin_block_id: 12 },
        { admin_block_name: 'Уголок потребителя', admin_block_id: 13 },
      ],

      zones: [],
      blocks: [],
      api: 'https://sbotapi.fitauto.ru/v3/bots/shopper/'
    }),
    computed: {},
    watch: {
      selectedBlock: async function () {
        this.newQ.block_id = this.selectedBlock
        await this.getQuestions(this.selectedBlock)
      }
    },
    methods: {
      saveEdit: async function () {
        this.editStepDialog = false
        try {
          await this.$http.put(`${this.api}steps/full`, {steps: [this.steps[this.editStepIndex]]})
          this.getQuestions(this.selectedBlock)
        } catch (e) {
          console.log('Step state error!', e)
        }
        this.editStepIndex = null
      },
      closeEdit: async function () {
        this.editStepIndex = null
        this.editStepDialog = null
      },
      checkCrypto: async function () {
        try {
          const r = await this.$http.post(`https://sbotapi.fitauto.ru/v3/crypto/inspector`, {
            id: this.$route.query.id,
            first_name: this.$route.query.first_name,
            last_name: this.$route.query.last_name,
            username: this.$route.query.username,
            photo_url: this.$route.query.photo_url,
            auth_date: this.$route.query.auth_date,
            hash: this.$route.query.hash,
          })
          console.log({
            hash: this.$route.query.hash,
            comparedHash: r.data.compareString
          })
          this.compared = r.data.compareString === this.$route.query.hash
        } catch (e) {
          console.log('Hash checking error!')
        }
      },
      addStep: async function () {
        try {
          console.log('STEP:', {
            order: this.newQ.order,
            action: this.newQ.action,
            question: this.newQ.question,
            file: this.newQ.file,
            type: this.newQ.type,
            factor: this.newQ.factor,
            skip: this.newQ.skip,
            cat_id: this.newQ.cat_id,
            admin_block_id: this.newQ.admin_block_id,
            block_id: this.newQ.block_id,
            act_text: this.newQ.act_text,
            exclude_from_repair: this.newQ.exclude_from_repair
          })
          await this.$http.post(`${this.api}steps`, {
            order: this.newQ.order,
            action: this.newQ.action,
            question: this.newQ.question,
            file: this.newQ.file,
            factor: this.newQ.factor,
            type: this.newQ.type,
            skip: this.newQ.skip,
            cat_id: this.newQ.cat_id,
            admin_block_id: this.newQ.admin_block_id,
            block_id: this.newQ.block_id,
            act_text: this.newQ.act_text,
            exclude_from_repair: this.newQ.exclude_from_repair
          })
          this.newQ =  {
            order: 1,
            type: 'photo+commentOnNo',
            action: '',
            question: '',
            factor: 1,
            cat_id: 0,
            skip: 0,
            file: '',
            admin_block_id: 0,
            block_id: this.selectedBlock,
            act_text: '',
            exclude_from_repair: null,
          }
          this.getQuestions(this.selectedBlock)
        } catch (e) {
          console.log(e)
        }
      },
      deleteQuestion: async function (index) {
        let step_id = this.steps[index].step_id
        this.steps.splice(index, 1)
        let newQuestions = []
        this.steps.forEach(el => {
          newQuestions.push(el)
          newQuestions[newQuestions.length - 1].order = newQuestions.length
        })
        this.steps = newQuestions

        try {
          await this.$http.delete(`${this.api}steps/${step_id}`)
          await this.$http.put(`${this.api}steps/full`, {questions: this.steps})
          this.getQuestions(this.selectedBlock)
          this.deleteQuestionIndex = 0
          this.confirmDeleteQuestion = false
        } catch (e) {
          console.log(e)
        }
      },
      editStepItem: function (index, item) {
        this.editStepDialog = true
        this.editStepIndex = index
        console.log({
          index,
          item
        })
      },
      preDeleteQuestion: function (index) {
        this.confirmDeleteQuestion = true
        this.deleteQuestionIndex = index
      },
      saveQuestion: async function (index) {
        try {
          await this.$http.put(`${this.api}steps/full`, {steps: [this.steps[index]]})
          this.getQuestions(this.selectedBlock)
        } catch (e) {
          console.log('Step state error!')
        }
      },
      itemUp: function (index) {
        let current = this.steps[index]
        this.steps.splice(index, 1)
        current.order = +(current.order) - 1
        this.steps[index - 1].order = +(this.steps[index - 1].order) + 1
        this.steps.splice(index - 1, 0, current)
        try {
          this.$http.put(`${this.api}steps/order`, {steps: this.steps})
        } catch (e) {
          console.log('Step state error!')
        }
      },
      itemDown: function (index) {
        let current = this.steps[index]
        this.steps.splice(index, 1)
        current.order = +(current.order) + 1
        this.steps[index].order = +(this.steps[index].order) - 1
        this.steps.splice(index + 1, 0, current)

        try {
          this.$http.put(`${this.api}steps/order`, {steps: this.steps})
        } catch (e) {
          console.log('Step state error!')
        }
      },
      getQuestions: async function (zone_id) {
        try {
          const r = await this.$http.get(`${this.api}steps/${zone_id}`)
          this.steps = r.data
          this.newQ.order = (this.steps[this.steps.length -1]) ? this.steps[this.steps.length -1].order + 1 : 1
        } catch (e) {
          console.log(e)
        }
      },
      deleteBlock: async function (index) {
        console.log(index)
      },
      getBlocks: async function () {
        try {
          const r = await this.$http.get(`${this.api}blocks`)
          this.blocks = r.data
        } catch (e) {
          console.log(e)
        }
      },
      getCats: async function () {
        try {
          const r = await this.$http.get(`${this.api}cats`)
          this.cats = r.data
        } catch (e) {
          console.log(e)
        }
      },
      addBlock: async function () {
        try {
          const r = await this.$http.post(`${this.api}blocks`, this.newzone)
          this.getBlocks()
          this.newzone = {
            name: null,
            prolog: null,
            epilog: null,
            nextblock: null,
          }
        } catch (e) {
          console.log(e)
        }
      },
      deleteBlock: async function (block_id) {
        try {
          const r = await this.$http.delete(`${this.api}blocks/${block_id}`)
          this.getBlocks()
        } catch (e) {
          console.log(e)
        }
      },
      saveBlock: async function (item) {
        try {
          const r = await this.$http.patch(`${this.api}blocks/${item.block_id}`, {
            name: item.block_name,
            prolog: item.prolog,
            epilog: item.epilog,
            nextblock: item.next_block_id,
          })
          this.getBlocks()
        } catch (e) {
          console.log(e)
        }
      },
      codeBx: async function() {
        try {
          const r = await this.$http.get(`${this.api}maxcodebx`)
          this.newQ.code = +(r.data[0].CodeBxMax) + 1
        } catch (e) {
          console.log(e)
        }
      }
    },
    mounted () {
      //this.checkCrypto()
      this.getBlocks()
      this.getCats()
      //this.codeBx()
    }
  }
</script>
<style>

</style>
